<nav class="head-nav">
  <div class="nav-container">
    <div>
      <h2>{{ "content4.Guests Reviews" | translate }}</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="restaurantId">
          <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
        </li>
        <li class="breadcrumb-item">{{ "content4.Guests Reviews" | translate }}</li>
      </ol>
    </div>
    <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData();"></app-restaurants-dropdown>
  </div>
</nav>

<div class="page">

  <div class="page-filters mb-3">
    <div class="top-rates d-flex mb-4 w-100" *ngIf="topRates">
      <div class="rate m-0">
        <p class="font-24 fontSemiBold mb-0">{{topRates.totalRateReview}}</p>
        <ngb-rating [max]="5" [(rate)]="topRates.totalRateReview" [readonly]="true" [starTemplate]="rate1"
          class="star-rating-top">
          <ng-template #rate1 let-fill="fill">
            <i class="fa fa-star star" [ngClass]="{'fa-star-o yellow' : fill > 0 , 'fa-star' : fill == 0}">
              <i class="fa fa-star-o filled" [style.width.%]="fill"
                [ngClass]="{'fa-star-o' : fill == 0 , 'fa-star' : fill > 0}"></i>
            </i>
          </ng-template>
        </ngb-rating>
        <p class="font-12 fontLight">({{topRates.totalReviewsCount}} {{ 'restaurant.Reviews' | translate }})</p>
      </div>
      <div class="rate-block d-flex ml-auto pr-5">
        <div class="rate mt-3" *ngFor="let rateReview of topRates?.servicesReviewsTotal">
          <ng-container *ngIf="rateReview.serviceRateTypeTotal == 'StarRating'">
            <p class="font-16 fontMedium">{{rateReview.serviceNameTotal}}</p>
            <ngb-rating [max]="5" [(rate)]="rateReview.serviceRateTotal" [readonly]="true" [starTemplate]="rate"
              class="star-rating">
              <ng-template #rate let-fill="fill">
                <i class="fa fa-star star" [ngClass]="{'fa-star-o yellow' : fill > 0 , 'fa-star' : fill == 0}">
                  <i class="fa fa-star-o filled" [style.width.%]="fill"
                    [ngClass]="{'fa-star-o' : fill == 0 , 'fa-star' : fill > 0}"></i>
                </i>
              </ng-template>
            </ngb-rating>
          </ng-container>
          <ng-container *ngIf="rateReview.serviceRateTypeTotal == 'DashRating'">
            <p class="font-16 fontMedium">{{rateReview.serviceNameTotal}}</p>
            <ngb-rating [max]="5" [(rate)]="rateReview.serviceRateTotal" [readonly]="true" [starTemplate]="line"
              class="line-rating">
              <ng-template #line let-fill="fill">
                <i class="line" [ngClass]="{'line-o yellow' : fill > 0 , 'line' : fill == 0}">
                  <i class="line-o filled" [style.width.%]="fill"
                    [ngClass]="{'line-o' : fill == 0 , 'line' : fill > 0}"></i>
                </i>
              </ng-template>
            </ngb-rating>
          </ng-container>
        </div>
      </div>
    </div>

    <br>

    <ng-container *ngIf='!dataLoading'>
      <div class="sort-item">
        <span class="count-page">
          <span>{{listData?.listReviews?.length}}</span> {{ 'restaurant.Reviews' | translate }}
        </span>
      </div>
      <div class="button-group-custom">
        <div class="tabs-bordered">
          <mat-button-toggle-group [(ngModel)]="filterModel.rates" (change)="typeFilter($event)">
            <mat-button-toggle *ngFor="let status of typesListAll" [value]="status.id" [disabled]="dataLoading">
              <span class="font-15 fontRegular with-icon">{{status.name}}</span>
              <i class="fa fa-star"></i>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <div class="filters-container">
        <div class="search-input">
          <mat-form-field appearance="legacy" *ngIf="showSearch">
            <input matInput autocomplete="off" [(ngModel)]="filterModel.searchText" (keydown.enter)="makeSearch()"
              maxlength="20">
            <mat-icon (click)="resetSearch(); showSearch = false;" matSuffix>clear</mat-icon>
          </mat-form-field>
          <button mat-icon-button (click)="makeSearch()">
            <img src="./assets/images/icons/search.svg">
          </button>
        </div>
        <button (click)="showFilter = !showFilter" [ngClass]='{"active": showFilter}' class="btn dropdown-custom">
          <img src="./assets/images/icons/filter-outline.svg">
          <span>{{"general.Filter" | translate}}</span>
          <svg width="8" height="5.001" viewBox="0 0 8 5.001">
            <path id="menu-icon" d="M-3.562-9.316-.5-6.215l3.062-3.1.938.949-4,4.051-4-4.051Z"
              transform="translate(4.5 9.316)" fill="#6a6a6a" opacity="0.8" />
          </svg>
        </button>
      </div>

      <div class="filter-section" [hidden]="!showFilter">
        <h4 class="title">{{"general.Filter by" | translate}}</h4>
        <div [formGroup]="filterFormGroup" class="row">
          <div class="col-lg-3 mb-3">
            <mat-form-field class="no-validation">
              <mat-label>{{"forms.Date From" | translate}}</mat-label>
              <input matInput [matDatepicker]="dateFrom" formControlName='dateFrom' [max]="filterFormGroup.controls['dateTo'].value || today" readonly
              (focus)="dateFrom.open()" (click)="dateFrom.open()">
              <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['dateFrom'].value"
                (click)="filterFormGroup.controls['dateFrom'].setValue(''); makeFilter();">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
              <mat-datepicker #dateFrom></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-lg-3 mb-3">
            <mat-form-field class="no-validation">
              <mat-label>{{"forms.Date To" | translate}}</mat-label>
              <input matInput [matDatepicker]="dateTo" formControlName='dateTo' [min]="filterFormGroup.controls['dateFrom'].value" readonly
              (focus)="dateTo.open()" (click)="dateTo.open()">
              <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['dateTo'].value"
                (click)="filterFormGroup.controls['dateTo'].setValue(''); makeFilter();">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
              <mat-datepicker #dateTo></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="btn-container">
          <button mat-stroked-button color="primary" (click)="makeFilter()">{{"general.Apply Filter" |
            translate}}</button>
          <button mat-stroked-button (click)="clearFilter()">{{"general.Clear Filter" |
            translate}}</button>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
  <ng-container *ngIf='!dataLoading'>
    <div *ngIf="listData?.listReviews && listData?.listReviews?.length; else dataEmpty">

      <div class="table-responsive table-container">
        <table class="table table-primary no-background">
          <thead>
            <tr>
              <th>{{'content4.Reviewer' | translate}}</th>
              <th>{{'restaurant.Rate' | translate}}</th>
              <th style="width: 30%;">{{'content4.Review' | translate}}</th>
              <th>{{'content4.Date & Time' | translate}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listData?.listReviews">
              <td>
                <div class="name-with-image">
                  <div class="image-circle">
                    <ng-container>
                      <span *ngIf="!item.icon">{{ item.name | shortName }}</span>
                      <img *ngIf="item.icon" [src]="item.icon" (error)="item.icon = ''">
                    </ng-container>
                    <!-- <ng-container *ngIf="item.isPostedanonymously">
                      <img src="./assets/images/avatar.png" alt="">
                    </ng-container> -->
                  </div>
                  <div class="name">
                    <ng-container>
                      <a class="font-14 fontMedium linkable" (click)="selectedReviewId = item.reviewId">
                        {{item.name}}
                      </a>
                      <span class="badge badge-pill badge-light ml-2" *ngIf="item.isPostedanonymously">{{ 'reviews.Anonymous User' | translate }}</span>
                    </ng-container>
                  </div>
                </div>
              </td>
              <td class="font-14 fontRegular">
                <ng-container *ngIf="item.reviewRate != 0; else skipped">
                  <span class="font-14 fontRegular pr-3">{{item.reviewRate}}</span>
                  <ngb-rating [max]="5" [(rate)]="item.reviewRate" [readonly]="true" [starTemplate]="rate">
                    <ng-template #rate let-fill="fill">
                      <i class="fa fa-star star">
                        <i *ngIf="fill > 0" class="fa fa-star filled" [style.width.%]="fill"></i>
                      </i>
                    </ng-template>
                  </ngb-rating>
                </ng-container>
                <ng-template #skipped>{{ 'reviews.skipped' | translate }}</ng-template>
              </td>
              <td class="font-14 fontRegular">{{item.reviewComment}}</td>
              <td class="font-14 fontRegular">
                {{item.reviewDateTime | date:'d MMMM, y'}} {{'content4.at' | translate }} {{item.reviewDateTime | date:'shortTime'}}
              </td>
              <td>
                <div class="d-flex align-items-center justify-content-end">
                  <div class="mr-2">
                    <div class="status-badge grey" *ngIf="item.reportStatus == 'Reported'">{{'reviews.Reported' | translate}}</div>
                    <div class="status-badge orange" *ngIf="item.reportStatus == 'Resolved'">{{'reviews.Resolved' | translate}}</div>
                  </div>

                  <div class="btn-actions">
                    <button mat-icon-button *ngIf="item.canReport"
                    [matTooltip]="'reviews.Report review content' | translate"
                    (click)="openReportForm(item.reviewId)">
                      <mat-icon class="red-color">flag</mat-icon>
                    </button>

                    <a mat-icon-button [matTooltip]="'general.View' | translate"
                      (click)="selectedReviewId = item.reviewId">
                      <mat-icon>remove_red_eye</mat-icon>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>

        </table>
      </div>

      <div class="pagination-container"
      *ngIf="listData && (pageCount > 1 || listData['totalCount'] > pageSize)">
        <mat-paginator [length]="listData['totalCount']" [pageSize]="filterModel.pageSize"
          [pageSizeOptions]="[5, 10, 20]" (page)="getAll($event, restaurantId)" [pageIndex]="filterModel.pageNumber">
        </mat-paginator>
      </div>

    </div>
  </ng-container>

  <!-- <ng-template #dataEmpty>
    <empty-state [title]='"content4.Reviews list is empty" | translate'
      [img]="'/assets/images/icons/reviews-empty.svg'"></empty-state>
  </ng-template> -->

  <ng-template #dataEmpty>
    <empty-state [title]='"general.No Data Found" | translate'></empty-state>
</ng-template>
</div>

<app-guest-review-details *ngIf="selectedReviewId"
  [selectedReviewId]="selectedReviewId"
  [restaurantId]="restaurantId"
  (close)="closeDetails()"></app-guest-review-details>
